import { isProduction } from '../../../utils/appEnv';

export const googleMapsApiKey = isProduction
  ? 'AIzaSyAZ4jf1YdDuQvUoV2LHdaDYdFvxV8cbIBM'
  : 'AIzaSyBCZw8wyizGZ_iADmtvcgiQhBcsRmkKoaM';
